/**
 * How often the peering list refreshes itself.
 *
 * The poll is a plain toolkit `useInterval`, not `useQuery`'s built-in polling:
 * this list is driven by `EntityList`, which owns its `useQuery` internally and
 * forwards only `pollDataSource$` — neither `pollInterval` nor `pollUntil` is
 * exposed as a prop, so the interval and the stop condition are unreachable
 * from here.
 *
 * A fixed interval with no status gate matches the other polled lists in this
 * codebase (PIPELINE_STATS_POLL_PERIOD, ACTIVITY_TIMELINE_POLL_INTERVAL).
 */
export const PEERING_POLL_INTERVAL = 10000;
